export default "__VITE_ASSET__BhTEWWs0__"